module.exports = __webpack_public_path__ + "img/splash.6784e298.png";